import { render, staticRenderFns } from "./systemKnowledge.vue?vue&type=template&id=4c2b2a9e"
import script from "./systemKnowledge.vue?vue&type=script&lang=js"
export * from "./systemKnowledge.vue?vue&type=script&lang=js"
import style0 from "./systemKnowledge.vue?vue&type=style&index=0&id=4c2b2a9e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports